import React, {useReducer, useContext, useRef} from "react";
import axios from 'axios';
// import Fade from 'react-reveal/Fade';

import CONSTS from "./components/faq-search-constants";
import {Trail, Transition} from "react-spring/renderprops-universal";


function searchReducer(faqState, action) {
    console.log("State: ", faqState, "Action: ", action);
    switch (action.type) {

        case CONSTS.UPDATE_SEARCH_FIELD:
            if (faqState.searchHintsTimer) {
                clearTimeout(faqState.searchHintsTimer);
            }

            return {...faqState, searchPhrase:action.value, searchHintsTimer:setTimeout( function (e) {
                    action.callback(action.value);
            },200)};

        case CONSTS.SEARCH_HINTS_LOADING:
            return {...faqState, searchHintsLoading: action.loading};

        case CONSTS.UPDATE_HINTS:
            return {...faqState, searchHints: action.hints};

        case CONSTS.FOCUS:
            return {...faqState, focused: action.focus};
    }
}


function SiteSearch(props) {
    const [searchState, doAction] = useReducer(searchReducer, {
        searchPhrase:props.searchPhrase,
        searchHints:[],
        searchHintsLoading:false,
        focused:false
    });

    let searchFieldRef = React.createRef();

    const AxiosCancelToken = axios.CancelToken;
    let cancelHandler;

    function pullNewHints(search) {
        doAction({type:CONSTS.SEARCH_HINTS_LOADING, loading:true});

        cancelHandler && cancelHandler(); //Cancel previous if exists

        if (!search.length) {
            doAction({type:CONSTS.UPDATE_HINTS, hints:[]});
            return;
        }

        let formData = {
            search: search
        };

        axios.post('/search-hints', formData, {
            cancelToken: new AxiosCancelToken(function executor (c) {
                cancelHandler = c;
            })
        })
            .then(function (response) {
                // console.log(response);
                switch (response.data.status) {
                    case 'OK':
                        doAction({type:CONSTS.UPDATE_HINTS, hints:response.data.data});
                        break;
                    case 'ERROR':
                        doAction({type:CONSTS.UPDATE_HINTS, hints:[]});
                        break;
                }
            })
            .catch(function (error) {
                doAction({type:CONSTS.UPDATE_HINTS, hints:[]});
            })
            .then(() => { //ALWAYS
                doAction({type:CONSTS.SEARCH_HINTS_LOADING, loading:false});
            })
        ;
    }

    const searchTimer = useRef(null);

    function queueNewHints(search) {
        if (searchTimer.current) {
            clearTimeout(searchTimer.current);
        }

        searchTimer.current = setTimeout(function (event) {

            searchTimer.current = null;

            pullNewHints(search);
        }, 200);
    }

    function onSearchFieldChange(e) {
        doAction({type:CONSTS.UPDATE_SEARCH_FIELD, value:e.target.value, callback:queueNewHints});
    }


    return  (
        <>
            <form autocomplete="off" role="search" method="get" className={"search-form " + ((searchState.searchHintsLoading) ? 'loading' : '') + (searchState.searchHints.length ? ' has-hints':'')} action="/search">
                <label>
                    <span className="screen-reader-text">Search for: </span>
                </label>
                <input type="text"
                       className="search-field"
                       placeholder="Search"
                       name="phrase"
                       onChange={e => onSearchFieldChange(e)}
                       onBlur={e => doAction({type:CONSTS.FOCUS, focus:false})}
                       onFocus={e => doAction({type:CONSTS.FOCUS, focus:true})}
                       ref={searchFieldRef}
                       value={searchState.searchPhrase}
                />
                <input type="submit" className="search-submit" value="Search"/>
                <div className="close-search-form" />
            </form>

            <Transition
                items={(searchState.focused && searchState.searchHints.length > 0 && searchState.searchPhrase.length > 0)}
                from={{ opacity: 0 }}
                enter={{ opacity: 1 }}
                leave={{ opacity: 0 }}>
                {show => show && (props =>
                    <ul className={"search-hints " + ((searchState.focused) ? 'focused' : '') + ((searchState.searchHints.length > 0 && searchState.searchPhrase.length >0 )? ' has-hints':'')} style={props}>
                        <Trail items={searchState.searchHints} from={{transform: 'translate3d(0,20px,0)', opacity:0}} to={{transform: 'translate3d(0,0px,0)', opacity:1}}>
                            {item => props =>
                                <li className="hint layout-item" style={props}>
                                    <a href={item.url} target={((item.zendesk_url)?'_blank':'_self')} >{item.post_title} <span className="category-name has-grey-color">| {item.category}</span></a>
                                </li>
                            }
                        </Trail>
                    </ul>
                )}
            </Transition>


        </>
    );
}

export { SiteSearch };

